import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';
import euiFormTextruta from 'v-components/euiFormTextruta.vue';
import euiFormKryssruta from 'v-components/euiFormKryssruta.vue';

import { ValidationObserver } from 'vee-validate';

import objectToFormData from 'object-to-formdata';

import VeeValidateRemote from 'VeeValidateRemote';
VeeValidateRemote.runOnce();	// Kör funktionen om den inte redan körts!


window.ssoMinProfil = window.ssoMinProfil || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiFormTextruta,
		euiFormKryssruta,
		'validation-observer': ValidationObserver,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {

		// Obs! Måste stämma med form model som används i controllern:
		minProfilFormModel: window.ssoMinProfil.minProfilFormModel,

		formReadOnly: true,	// Initialt read-only.

		minProfilFormModelUndansparad: null,	// Sätts i created() m.fl. ställen
	},

	methods: {

		onAndra()
		{
			this.formReadOnly = false;
		},

		onSpara() {

			// Validera först!
			this.$refs.validationsobserveraren.validate()
				.then((isValid) => {

					if (!isValid) {
						// Om formuläret inte validerar:
						// Då har feltexter visats i formuläret:
						// Bara aborta emittandet.
					}
					else
					{
						// Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/installningar/min-profil-update', {
							formData: objectToFormData(this.minProfilFormModel),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Återgå till read-only-läget:
								this.formReadOnly = true;

								this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
								this.pollContext();
							},
						});
					}
				});

			//// reset state, flags and clears errors.
			//this.$validator.reset();

		},

		// Utgått till förmån för en Avbryt istället pga nytt pattern: onAterstall() {
		onAvbryt() {

			// Återställ till undansparade värden:
			this.minProfilFormModel = Object.assign({}, this.minProfilFormModelUndansparad);

			this.formReadOnly = true;
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		// Spara undan initiala värden:
		this.minProfilFormModelUndansparad = Object.assign({}, this.minProfilFormModel);
	},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

// Görs nu i ssoAllaSidorMixin:
//console.time('#TIMING: initieraTooltips');	// Todo: TEMP!!!
//ssoTooltips.initiera(document.body);
//console.timeEnd('#TIMING: initieraTooltips');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;


